import { createActionType } from 'app/store/utils';

const type = createActionType('inventory');

export const ADD_XML = type('AddXML');
export const REMOVE_XML = type('RemoveXML');
export const TOGGLE_GROUP = type('ToggleGroup');
export const SELECT_NODE = type('SelectNode');
export const SET_FILTER = type('SetFilter');
export const CLEAR_FILTERS = type('ClearFilters');
export const SET_SEARCH_TERM = type('SetSearchTerm');
export const SET_NOTES = type('SetNotes');
